export default "__VITE_ASSET__CPIDtLAl__"